import { render, staticRenderFns } from "./TasksComponent.vue?vue&type=template&id=424a1bda&scoped=true&"
import script from "./TasksComponent.vue?vue&type=script&lang=js&"
export * from "./TasksComponent.vue?vue&type=script&lang=js&"
import style0 from "./TasksComponent.vue?vue&type=style&index=0&id=424a1bda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a1bda",
  null
  
)

export default component.exports